export default [
  {
    id: 1,
    caption: "golf is pretty great"
  },
  {
    id: 2,
    caption: "sports get me energized"
  },
  {
    id: 3,
    caption: "golf is the greatest sports game"
  },
  {
    id: 4,
    caption: "who likes fish in the morning"
  },
  {
    id: 5,
    caption: "i need food to get me through the day"
  },
  {
    id: 6,
    caption: "let's make a fishy for dinner"
  },
  {
    id: 7,
    caption: "so many jobs lately"
  },
  {
    id: 8,
    caption: "just got a good job"
  },
  {
    id: 9,
    caption: "got to check my medicine"
  },
  {
    id: 10,
    caption: "how can that be yours"
  }
];
